export const DURATION_10_MINUTES = 10 * 60 * 1000;
